import { createContext, useContext } from 'react'

import type { PageSkills, SavedResources } from 'features/project/page-skills'

export interface PageSkillsRegistrationType {
  setPageSkills: (pageSkills: PageSkills | null) => void
  setIsAskYogiAnywhereOpen: (open: boolean) => void
}

const noop = (): void => {}

/**
 * The setters a page pushes its skills through. Stable, and on its own context
 * for the reason `ChartPageRegistrationContext` is: a page that only pushes
 * must not re-render whenever the widget opens or closes.
 *
 * Defaults to no-ops, so a page renders without the widget's provider (tests,
 * stories) and simply registers nothing.
 */
export const PageSkillsRegistrationContext =
  createContext<PageSkillsRegistrationType>({
    setPageSkills: noop,
    setIsAskYogiAnywhereOpen: noop,
  })

export const usePageSkillsRegistration = (): PageSkillsRegistrationType =>
  useContext(PageSkillsRegistrationContext)

/** The hand-back half: changes only when a live turn saved something. */
export const SavedResourcesContext = createContext<SavedResources | null>(null)

export const useSavedResourcesHandBack = (): SavedResources | null =>
  useContext(SavedResourcesContext)
